import { HCP_SEGMENTATION_CUBE_NAME } from '@/api/hcp';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';

const VALUE_AND_MOTIVATION_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.value_and_motivation`],
  limit: undefined,
});

const valueAndMotivationFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.valueAndMotivationLabel',
  sourceCube: HCP_SEGMENTATION_CUBE_NAME,
  defaultValue: [],
  getOptionsQuery: VALUE_AND_MOTIVATION_OPTIONS,
  mapResult: mapDimensionToOption(`${HCP_SEGMENTATION_CUBE_NAME}.value_and_motivation`),
  type: 'multiselect',
  clearable: true,
  placeholder: 'global.filters.formControls.valueAndMotivationPlaceholder',
  searchable: true,
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `${HCP_SEGMENTATION_CUBE_NAME}.value_and_motivation`,
      operator: 'equals',
      values: [...v],
    };
  },
};

export default valueAndMotivationFilter;
